import React, {Component} from 'react';
import {NavLink,withRouter} from 'react-router-dom';
// import logo from '../../assets/img/brand/WellLynx-logo.png';
// import logoMin from '../../assets/img/brand/WellLynx-min.png';
import svgEsp from '../icons/ESPGray.svg';
import svgSRP from '../icons/SRPGray.svg';
import svgML from '../icons/Machine-Learning-Gray.svg';
import svgHealth from "../icons/Health-Index-Gray.svg"
import AppConfiguration from "../../assets/Configuration/ConfigurationFile.json"
import '../../scss/App.scss';

class Aside extends Component {
  constructor(props){
    super(props);
    this.logoName=require(`../../assets/img/brand/${AppConfiguration.clientName ==='driveLynx' ?AppConfiguration.logoName.replace('svg','png') : AppConfiguration.logoName }`)
    this.logoMinName=require(`../../assets/img/brand/${AppConfiguration.sygnet}`)

    // console.log({logoName: this.logoName, logoMinName: this.logoMinName});
    
  }

  renderFullLogo(){
    let fullLogo=<div></div>

    try {
      switch (AppConfiguration.clientName) {
        case "driveLynx":
          fullLogo=<img style={{cursor: 'pointer',maxHeight: '100px'}} src={this.logoName} alt={`${AppConfiguration.clientName}`} />
          break;
        case "harouge":
          fullLogo=<img style={{cursor: 'pointer',maxHeight: '50px'}} src={this.logoName} alt={`${AppConfiguration.clientName}`} />
          break;
          case "mellitah":
            fullLogo=<img style={{cursor: 'pointer',maxHeight: '70px'}} src={this.logoName} alt={`${AppConfiguration.clientName}`} />
            break;
            case "alitheflow":
              fullLogo=<img style={{cursor: 'pointer',maxHeight: '40px'}} src={this.logoName} alt={`${AppConfiguration.clientName}`} />
              break;
        default:
          fullLogo=<img style={{cursor: 'pointer'}} src={this.logoName} alt={`${AppConfiguration.clientName}`} />
          break;
      }  
    } catch (e) {
      console.log(e);
    }
    return fullLogo
  }

  render() {
    const url=this.props.match.path;
    return (
            <section className="sidebar">
              <div className="user-panel">
                <div className="ulogo">
                  <NavLink to="/wlmgHome">
              <span>
                {this.renderFullLogo()}
              </span>
                  </NavLink>
                </div>
                <div className="image">
                  <NavLink to="/wlmgHome">
                    <div className='logo-min-wrapper'>
                      <img  src={this.logoMinName} style={{cursor: 'pointer'}} 
                            className="logo-min" 
                            alt={`${AppConfiguration.docTitle}Sygnet`}/>
                    </div>
                  </NavLink>
                </div>
              </div>
              <ul className="sidebar-menu" data-widget="tree">
              {
                AppConfiguration.clientName !== "dmz" && (
                  <>
                    <li>
                      <NavLink to="/wlmgUsers">
                        <i className="menu-user-icon"/>
                        <span>Users</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/wlmgGroups">
                        <i className="menu-group-icon"/>
                        <span>Groups</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/wlmgProducers">
                        <i className="menu-producer-icon"/>
                        <span>Producers</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/wlmgFields">
                        <i className="menu-field-icon"/>
                        <span>Fields</span>
                      </NavLink>
                    </li>
                    <li className="treeview">
                      <a className={`${['/wlmgAllWells','/wlmgGeneric','/wlmgEsp','/wlmgSrp','/wlmgSkid','/wlmgHorizPump'].includes(url) ? 'active' : ''}`}>
                        <i className="menu-assets-icon"/>
                        <span>Assets</span>
                        <span className="pull-right-container">
                          <i className="fa fa-angle-right pull-right"/>
                        </span>
                      </a>
                      <ul className="treeview-menu">
                        <li><NavLink to="/wlmgAllWells">All Assets</NavLink></li>
                        <li><NavLink to="/wlmgGeneric">Generic</NavLink></li>
                        <li><NavLink to="/wlmgEsp">
                          <img width="30px" height="30px" src={svgEsp} alt="ESP icon"/>
                          <span>ESP</span>
                        </NavLink></li>
                        <li><NavLink to="/wlmgSrp">
                          <img width="30px" height="30px" src={svgSRP} alt="SRP icon"/>
                          <span>SRP</span>
                        </NavLink></li>
                        <li><NavLink to="/wlmgSkid">
                          <img width="30px" height="30px" src={svgEsp} alt="Skid icon"/>
                          <span>Skid</span>
                        </NavLink></li>
                        <li><NavLink to="/wlmgHorizPump">
                          <img width="30px" height="30px" src={svgSRP} alt="Horiz Pump icon"/>
                          <span>Horiz Pump</span>
                        </NavLink></li>
                      </ul>
                    </li>
                    <li className="treeview">
                      <a className={`${['/wlmgTags','/wlmgStateTags'].includes(url) ? 'active' : ''}`}>
                        <i className="menu-tag-icon"/>
                        <span>Tags</span>
                        <span className="pull-right-container">
                          <i className="fa fa-angle-right pull-right"/>
                        </span>
                      </a>
                      <ul className="treeview-menu">
                        <li><NavLink to="/wlmgTags">Analog Tags</NavLink></li>
                        <li><NavLink to="/wlmgStateTags">State Tags</NavLink></li>
                      </ul>
                    </li>
                  </>
                )
              }
                {
                  AppConfiguration.isML && (
                      <li>
                        <NavLink to="/wlmgML">
                          <img width="30px" height="30px" className='mr-4' src={svgML} alt="Machine Learning icon"/>
                          <span>ML</span>
                        </NavLink>
                      </li>
                  )
                }
                {
                  AppConfiguration.clientName !== "dmz" && (
                    <li className="treeview">
                      <a className={`${['/wlHealth','/wlmgLutz'].includes(url) ? 'active' : ''}`}>
                      <img width="30px" height="30px" className='mr-4' src={svgHealth} alt="Health Index Icon"/>
                        <span>Optimization</span>
                        <span className="pull-right-container">
                          <i className="fa fa-angle-right pull-right"/>
                        </span>
                      </a>
                      <ul className="treeview-menu">
                        <li><NavLink to="/wlHealth">Health Index</NavLink></li>
                        <li><NavLink to="/wlmgLutz">Lutz Index</NavLink></li>
                       
                      </ul>
                    </li>
                  )
                }
              </ul>
              
            </section>
    );
  }
}

export default withRouter(Aside);
